import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { ScienceSection } from './components/ScienceSection';
import { WhatsInside } from './components/WhatsInside';
import { Results } from './components/Results';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initFacebookPixel, trackPageView } from './lib/fbpixel';
export function App() {
  useEffect(() => {
    initFacebookPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-bg font-sans text-text selection:bg-accent/30" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <ScienceSection data-id="element-5" />
        <WhatsInside data-id="element-6" />
        <Results data-id="element-7" />
        <Pricing data-id="element-8" />
        <FAQ data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}